import { errHandler } from "utils/common";
import api from "utils/api";

export default class BKKZeroReport {
  getAll = (opt = { searchBy: "", searchValue: "", page: 1, limit: 10 }) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/bkk-zero-reports`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  getTotalMalaria = (opt = { date: "", bkk_id: "" }) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/bkk-zero-report/total-malaria`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  add = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post("/api/bkk-zero-report?device=Online", payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  update = (payload, id) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/bkk-zero-report/${id}?device=Online`, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  remove = (id) => {
    return new Promise((resolve, reject) => {
      api
        .delete(`/api/bkk-zero-report/${id}?device=Online`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
